<template>
    <div class="mr-2">
        <button class="btn btn-danger my-auto" v-on:click="productDelete">
            <slot></slot>
        </button>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        props: {
            product_id: {
                required: true
            }
        },
        methods: {
            productDelete() {
                let request_url = `${base_url}/admin/api/products/${this.product_id}`;
                axios.delete(request_url)
                    .then((...success_response) => {
                        // console.log(success_response);
                        let data = success_response[0].data;
                        this.$emit('product:deleted', data)
                        return;
                    })
                    .catch((...error_response) => {
                        console.log(error_response);
                        return;
                    });
            }
        }
    };

</script>